import { Mountain, Instagram, Facebook, Twitter } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Mountain className="h-6 w-6" />
              <span className="font-heading text-2xl font-bold">Airbnmountain</span>
            </div>
            <p className="text-sm text-primary-foreground/70 leading-relaxed">
              Cabane de poveste, ciubăr și saună sub cerul liber, explorarea peșterilor ascunse din Munții Apuseni și conectarea cu energia naturii pure, nealterate de civilizație.
            </p>
          </div>
          {[
            { t: "Descoperă", l: ["Cabane A-Frame", "Chalete de lux", "Ciubăr & Saună", "Experiențe montane"] },
            { t: "Gazde", l: ["Devino gazdă", "Resurse pentru gazde", "Comunitatea", "Găzduire responsabilă"] },
            { t: "Asistență", l: ["Centru de ajutor", "Opțiuni anulare", "Siguranță", "Contact"] },
          ].map((col) => (
            <div key={col.t}>
              <p className="overline mb-4 text-primary-foreground/60">{col.t}</p>
              <ul className="space-y-3">
                {col.l.map((i) => (
                  <li key={i}><a href="#" className="text-sm text-primary-foreground/80 hover:text-accent transition-colors">{i}</a></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-primary-foreground/15 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-primary-foreground/60">© 2026 Airbnmountain · Făcut cu drag în România</p>
          <div className="flex gap-4">
            <Instagram className="h-5 w-5 text-primary-foreground/70 hover:text-accent cursor-pointer transition-colors" />
            <Facebook className="h-5 w-5 text-primary-foreground/70 hover:text-accent cursor-pointer transition-colors" />
            <Twitter className="h-5 w-5 text-primary-foreground/70 hover:text-accent cursor-pointer transition-colors" />
          </div>
        </div>
      </div>
    </footer>
  );
}
